import {Injectable} from "@angular/core";
import {environment} from "@env";

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractBaseApiService {

  protected apiTMIdentityServer: string = environment.apiTMIdentityServer;
  protected apiTMCustomer: string = environment.apiTMCustomer;
  protected apiTMVehicle: string = environment.apiTMVehicle;
  protected apiTMUniqueRegister: string = environment.apiTMUniqueRegister;
  protected apiTMSystemAccount: string = environment.apiTMSystemAccount;
  protected apiTMFinancial: string = environment.apiTMFinancial;
  protected apiTMTag: string = environment.apiTMTag;
  protected apiPostalCode: string = environment.apiPostalCode;
  protected apiTMTagTransaction: string = environment.apiTMTagTransaction;
  protected apiTMReport: string = environment.apiTMReport;
  protected apiTMIntegrationVPR: string = environment.apiTMIntegrationVPR;
  protected apiTMIntegrationSGA: string = environment.apiTMIntegrationSGA;
  protected apiTMContract: string = environment.apiTMContract;
  protected apiTMPartner: string = environment.apiTMPartner;

  constructor() {
  }

}
